import React from "react"

export class NullErrorBoundary extends React.Component {
  state = { error: false }
  componentDidCatch(error: Error, errorInfo: any) {
    console.error(error, errorInfo)

    if (
      error instanceof Error &&
      error.message.startsWith("Failed to fetch dynamically imported module")
    ) {
      // This is likely caused by a deploy
      const triedRefresh = window.localStorage.getItem("triedRefreshAt")
      if (!triedRefresh || Date.now() - parseInt(triedRefresh) > 1000 * 60 * 1) {
        window.localStorage.setItem("triedRefreshAt", Date.now().toString())
        window.location.reload()
      }
    }

    this.setState({ error: true })
  }

  render() {
    if (this.state.error) {
      return null
    } else {
      return this.props.children
    }
  }
}
